/* gk-urgency */
if (!customElements.get('gk-urgency')) {
  // Cache global que sobrevive ao re-render do <product-info> ao trocar variante.
  // Chaveado por handle do produto + range (min-max) + variante (size).
  window.__gkUrgencyCache = window.__gkUrgencyCache || {};

  class GkUrgency extends HTMLElement {
    connectedCallback() {
      this.min = parseInt(this.dataset.min || '1', 10);
      this.max = parseInt(this.dataset.max || '10', 10);
      if (this.min < 1) this.min = 1;
      if (this.max < this.min) this.max = this.min;
      this.template = this.dataset.text || 'Últimas {count} unidades em stock';
      this.showBar = this.dataset.showBar !== 'false';
      this.productHandle = this.dataset.productHandle || 'product';

      this._lastKey = null;

      this.handleChange = this.handleChange.bind(this);

      this.renderInitial();

      // Listen amplo — qualquer change/click pode ter mudado a variante
      document.addEventListener('change', this.handleChange, true);
      document.addEventListener('click', this.handleChange, true);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.handleChange, true);
      document.removeEventListener('click', this.handleChange, true);
    }

    handleChange() {
      // Pequeno delay pra deixar o tema atualizar o estado
      clearTimeout(this._checkTimer);
      this._checkTimer = setTimeout(() => {
        const newKey = this.getTrackedKey();
        if (newKey !== this._lastKey) {
          this.updateForKey(newKey);
        }
      }, 30);
    }

    getTrackedKey() {
      const scope = this.closest('product-info') || this.closest('.product') || document;

      const radios = scope.querySelectorAll('input[type="radio"][name^="options["]:checked');
      if (radios.length > 0 && radios[0].value) return radios[0].value;

      const selects = scope.querySelectorAll('select[name^="options["]');
      for (let i = 0; i < selects.length; i++) {
        if (selects[i].value) return selects[i].value;
      }

      // Fallback: aria-checked / pressed em variant pills
      const ariaSel = scope.querySelectorAll('[aria-checked="true"][data-value], [aria-pressed="true"][data-value]');
      if (ariaSel.length > 0) {
        const v = ariaSel[0].dataset.value || ariaSel[0].getAttribute('value');
        if (v) return v;
      }

      return 'default';
    }

    randomCount() {
      const range = this.max - this.min + 1;
      return Math.floor(Math.random() * range) + this.min;
    }

    cacheKey(key) {
      return this.productHandle + '|' + this.min + '-' + this.max + '|' + key;
    }

    getOrCreateCount(key) {
      const ck = this.cacheKey(key);
      if (typeof window.__gkUrgencyCache[ck] !== 'number') {
        window.__gkUrgencyCache[ck] = this.randomCount();
      }
      return window.__gkUrgencyCache[ck];
    }

    progressForCount(count) {
      const range = this.max - this.min;
      if (range <= 0) return 90;
      const normalized = (count - this.min) / range;
      const pct = 95 - normalized * 60;
      return Math.round(pct);
    }

    buildHtml(count) {
      const text = this.template.replace(/{count}/g, count);
      let html = '<span class="gk-urg__text">' + text + '</span>';
      if (this.showBar) {
        html += '<span class="gk-urg__bar" aria-hidden="true"><span class="gk-urg__bar-fill" data-fill style="width:0%;"></span></span>';
      }
      return html;
    }

    renderInitial() {
      const key = this.getTrackedKey();
      this._lastKey = key;
      const count = this.getOrCreateCount(key);
      const pct = this.progressForCount(count);
      this.innerHTML = this.buildHtml(count);
      // anima de 0% até pct
      requestAnimationFrame(() => {
        const fill = this.querySelector('[data-fill]');
        if (fill) fill.style.width = pct + '%';
      });
    }

    updateForKey(key) {
      this._lastKey = key;
      const count = this.getOrCreateCount(key);
      const pct = this.progressForCount(count);

      // Animação "descarregar": barra vai pra 0%, depois reconstrói com novo texto + barra cresce
      const fill = this.querySelector('[data-fill]');
      if (fill) {
        fill.style.width = '0%';
      }

      setTimeout(() => {
        // Atualiza texto + reseta barra em 0%
        this.innerHTML = this.buildHtml(count);
        // Espera um frame, depois anima até pct
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const newFill = this.querySelector('[data-fill]');
            if (newFill) newFill.style.width = pct + '%';
          });
        });
      }, 350);
    }
  }
  customElements.define('gk-urgency', GkUrgency);
}
